var _excluded = ["value", "format", "suffixIcon", "className", "onOpenChange"];

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import generateConfig from 'rc-picker/lib/generate/moment';
import generatePicker from 'antd/es/date-picker/generatePicker';
import moment from 'moment';
import omit from 'omit.js';
import formMethods from '../utils/form-methods';
import './style/index.less';
import classnames from 'classnames';
import { CalendarOutlined } from 'iglooicon';
var DatePicker = generatePicker(_objectSpread(_objectSpread({}, generateConfig), {}, {
  getYear: function getYear(date) {
    return date.year() + 543;
  },
  setYear: function setYear(date, year) {
    var clone = date.clone();
    return clone.year(year - 543);
  },
  locale: _objectSpread(_objectSpread({}, generateConfig.locale), {}, {
    format: function format(locale, date, _format) {
      var clone = date.clone();

      if (_format.includes('YYYY')) {
        clone.add(543, 'years');
      }

      return clone.format(_format);
    }
  })
}));
var dateFormater = 'DD   /   MM   /   YYYY';

var IglooBuddhistDatePicker = function IglooBuddhistDatePicker(_ref) {
  var value = _ref.value,
      format = _ref.format,
      _ref$suffixIcon = _ref.suffixIcon,
      suffixIcon = _ref$suffixIcon === void 0 ? _jsx(CalendarOutlined, {
    style: {
      fontSize: 24
    }
  }) : _ref$suffixIcon,
      className = _ref.className,
      _onOpenChange = _ref.onOpenChange,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      focusStaus = _useState2[0],
      setFocus = _useState2[1];

  return _jsx(DatePicker, _objectSpread(_objectSpread({}, omit(props, formMethods)), {}, {
    value: value ? moment(value) : value,
    placeholder: dateFormater,
    format: format || dateFormater,
    inputReadOnly: true,
    suffixIcon: suffixIcon,
    className: classnames(className, 'igloo-date-picker-container', {
      'igloo-date-picker-focus': focusStaus
    }),
    onOpenChange: function onOpenChange(open) {
      setFocus(open);
      typeof _onOpenChange === 'function' && _onOpenChange(open);
    },
    dropdownClassName: "igloo-date-picker-panel",
    showToday: false
  }));
};

IglooBuddhistDatePicker.formItemPropsHandler = function (_ref2) {
  var format = _ref2.format;
  return {
    getValueFromEvent: function getValueFromEvent(m) {
      return +m;
    },
    previewFormater: function previewFormater(value) {
      return moment(value).format(format || dateFormater);
    },
    valueFormater: function valueFormater(value) {
      return value ? +moment(value) : value;
    },
    'element-allowClear': false
  };
};

export default IglooBuddhistDatePicker;